import { IVentureBase } from '../../models/ventures';
import {
  IUserAddressBase,
  IUserAssignmentBase,
  IUserBase,
} from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import { IUserCategoryBase } from '../../models/userCategories';

interface IDetailedUserCategories extends IUserCategoryBase {
  venture: IVentureBase;
}

interface IDetailedFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
}

export interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IDetailedFeatureGroup;
  host?: IUserBase;
  venture?: IVentureBase;
}

export interface IDetailedUser extends IUserBase {
  address?: IUserAddressBase;
  hostBlocked?: boolean;
  titularBlocked?: boolean;
  categories: IDetailedUserCategories[];
  userAssignments: IUserAssignment[];
}

export const showUsersService = async (
  userId: string,
): Promise<IDetailedUser> => {
  const { data } = await jhsfBookingsApi.get<IDetailedUser>(
    `/v2/users/${userId}`,
  );

  return data;
};
